// extracted by mini-css-extract-plugin
export var mapContainer = "index-module--mapContainer--Rvg3S";
export var contactInfoContainer = "index-module--contactInfoContainer--3xrBC";
export var contactInfoItem = "index-module--contactInfoItem--1zE8S";
export var list = "index-module--list--oQcp7";
export var item = "index-module--item--1RY35";
export var linkContainer = "index-module--linkContainer--2YWzY";
export var infoContainer = "index-module--infoContainer--mt4pQ";
export var url = "index-module--url--3VGwr";